const DownloadBanner = () => null;

export default DownloadBanner;
